import React from 'react';
import './index.css';

export interface Role {
  id: string;
  displayName: string;
}

export interface RoleBadgeProps {
  roles: Role[] | string[];
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  className?: string;
  maxDisplay?: number; // Optional: limit number of badges displayed
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ 
  roles, 
  variant = 'secondary', 
  className = '',
  maxDisplay 
}) => {
  if (!roles || roles.length === 0) {
    return <span className="text-muted">No roles assigned</span>;
  }

  const displayRoles = maxDisplay ? roles.slice(0, maxDisplay) : roles;
  const remainingCount = maxDisplay && roles.length > maxDisplay ? roles.length - maxDisplay : 0;

  return (
    <div className={className}>
      {displayRoles.map((role, index) => (
        <span 
          key={index} 
          className={`role-badge role-badge-${variant}`}
          title={typeof role === 'string' ? role : role.displayName}
        >
          {typeof role === 'string' ? role : role.displayName}
        </span>
      ))}
      {remainingCount > 0 && (
        <span className={`role-badge role-badge-${variant}`} title={`${remainingCount} more roles`}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

export default RoleBadge;